import { Amplify } from "aws-amplify";

/**
 * Configure AWS Amplify with Cognito authentication
 *
 * This simplified configuration avoids TypeScript errors by using a more
 * basic configuration approach. We'll add more sophisticated API and GraphQL
 * configuration as needed later.
 */
export const configureAWS = () => {
  if (!process.env.REACT_APP_AWS_REGION) {
    console.error("REACT_APP_AWS_REGION is not set");
    return;
  }
  if (!process.env.REACT_APP_USER_POOL_ID) {
    console.error("REACT_APP_USER_POOL_ID is not set");
    return;
  }

  if (!process.env.REACT_APP_USER_POOL_CLIENT_ID) {
    console.error("REACT_APP_USER_POOL_CLIENT_ID is not set");
    return;
  }

  if (!process.env.REACT_APP_IDENTITY_POOL_ID) {
    console.error("REACT_APP_IDENTITY_POOL_ID is not set");
    return;
  }

  // Comment out AppSync validation to prevent early return that blocks Auth configuration
  // if (!process.env.REACT_APP_APPSYNC_ENDPOINT) {
  //   console.error("REACT_APP_APPSYNC_ENDPOINT is not set");
  //   return;
  // }

  try {
    // Configuration for Amplify v6
    const region = process.env.REACT_APP_AWS_REGION;
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: process.env.REACT_APP_USER_POOL_ID,
          userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
          identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        },
      },
      // Add GraphQL config if needed
      API: {
        GraphQL: {
          endpoint: process.env.REACT_APP_APPSYNC_ENDPOINT || "https://placeholder-endpoint.com",
          region: region,
          defaultAuthMode: "userPool", // or 'apiKey', 'iam', etc.
        },
      },
    });

    console.log("AWS Amplify configured successfully");
  } catch (error) {
    console.error("Error configuring AWS Amplify:", error);
  }
};

export default configureAWS;
